<template>
  <div class="lista-acciones">
      <ol class="lista">
        <ListV2 v-for="(list, idx) in filterDataBase" 
          :key="`accion_${idx}`"
          :meta="list.linea_estrategica"
          :submetas="list.componente"
        />
      </ol>
  </div>
</template>

<script>
import ListV2 from "@/components/utiles/ListV2";
export default {
  name: 'ListadoAcciones',
  components: {
    ListV2,
  },
  data() {
    return {
      filterDataBase: [],
    }
  },
  props: {
    titulo: {
      type: String,
      default: "Título del Podcast",
    },
    lista: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.listaAcciones;
  },
  methods: {
    listaFilter(){
      this.filterDataBase = this.lista.filter(d => 
        d.linea_estrategica === this.titulo
      )
    }
  },
  computed: {
    listaAcciones(){
      this.listaFilter();
      return this.filterDataBase;
    }
  }
}
</script>

<style lang="scss" scoped>
.lista {
  // height: 205px;
  overflow-y: scroll;
  margin-top: 16px;
  margin-bottom: 16px;
  margin-right: 30px;  
  margin-left: 30px;
  padding-left: 0px;
  &:hover {
    // background: #F5F5F5;
  }
}
</style>